import React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={40} height={34} viewBox="0 0 40 34" {...props}>
      <title>{"briefcase"}</title>
      <path
        d="M37 6h-9V3c0-1.654-1.346-3-3-3H15c-1.654 0-3 1.346-3 3v3H3C1.346 6 0 7.346 0 9v22c0 1.654 1.346 3 3 3h34c1.654 0 3-1.346 3-3V9c0-1.654-1.346-3-3-3zM14 3a1 1 0 011-1h10a1 1 0 011 1v3H14V3zM3 8h34a1 1 0 011 1v15h-4v-1a1 1 0 00-1-1h-4a1 1 0 00-1 1v1H12v-1a1 1 0 00-1-1H7a1 1 0 00-1 1v1H2V9a1 1 0 011-1zm29 16v2h-2v-2h2zm-22 0v2H8v-2h2zm27 8H3a1 1 0 01-1-1v-5h4v1a1 1 0 001 1h4a1 1 0 001-1v-1h16v1a1 1 0 001 1h4a1 1 0 001-1v-1h4v5a1 1 0 01-1 1z"
        fill="#161657"
        fillRule="nonzero"
      />
    </svg>
  )
}

export const BriefcaseIcon = React.memo(SvgComponent)

BriefcaseIcon.displayName = "BriefcaseIcon"
